import Vue from 'vue';
import Router from 'vue-router';
import { Constants } from './constants';

import { loginRoute } from '@innorium/cn-client--sign-in';
const InSignIn: any = () => import('@innorium/cn-client--sign-in').then((module) => { return module.InSignIn; });

import { channelsRoute, channelDetailsRoute } from '@innorium/cn-client--channel';
const InChannelDetails: any = () => import('@innorium/cn-client--channel').then((module) => { return module.InChannelDetails; });
const InChannels: any = () => import('@innorium/cn-client--channel').then((module) => { return module.InChannels; });

import { bouquetsRoute, bouquetDetailsRoute } from '@innorium/cn-client--bouquet';
const InBouquetDetails: any = () => import('@innorium/cn-client--bouquet').then((module) => { return module.InBouquetDetails; });
const InBouquets: any = () => import('@innorium/cn-client--bouquet').then((module) => { return module.InBouquets; });

import { customerStbsRoute, customerStbDetailsRoute } from '@innorium/cn-client--customer-stb';
const InCustomerStbs: any = () => import('@innorium/cn-client--customer-stb').then((module) => { return module.InCustomerStbs; });
const InCustomerStbDetails: any = () => import('@innorium/cn-client--customer-stb').then((module) => { return module.InCustomerStbDetails; });

import { customersRoute, customerDetailsRoute } from '@innorium/cn-client--customer';
const InCustomers: any = () => import('@innorium/cn-client--customer').then((module) => { return module.InCustomers; });
const InCustomerDetails: any = () => import('@innorium/cn-client--customer').then((module) => { return module.InCustomerDetails; });

import { billsRoute } from '@innorium/cn-client--bills';
const InBills: any = () => import('@innorium/cn-client--bills').then((module) => { return module.InBills; });

import { billPreferencesRoute } from '@innorium/cn-client--bill-preference';
const InBillPreferences: any = () => import('@innorium/cn-client--bill-preference').then((module) => { return module.InBillPreferences; });

import { settingsRoute } from '@innorium/cn-client--settings';
const InSettings: any = () => import('@innorium/cn-client--settings').then((module) => { return module.InSettings; });

import { preferenceDetailsRoute } from '@innorium/cn-client--preference';
const InPreferenceDetails: any = () => import('@innorium/cn-client--preference').then((module) => { return module.InPreferenceDetails; });

import { countriesRoute, countryDetailsRoute } from '@innorium/cn-client--country';
const InCountryDetails: any = () => import('@innorium/cn-client--country').then((module) => { return module.InCountryDetails; });
const InCountries: any = () => import('@innorium/cn-client--country').then((module) => { return module.InCountries; });

import { statesRoute, stateDetailsRoute } from '@innorium/cn-client--state';
const InStateDetails: any = () => import('@innorium/cn-client--state').then((module) => { return module.InStateDetails; });
const InStates: any = () => import('@innorium/cn-client--state').then((module) => { return module.InStates; });

import { citiesRoute, cityDetailsRoute } from '@innorium/cn-client--city';
const InCityDetails: any = () => import('@innorium/cn-client--city').then((module) => { return module.InCityDetails; });
const InCities: any = () => import('@innorium/cn-client--city').then((module) => { return module.InCities; });

import { areasRoute, areaDetailsRoute } from '@innorium/cn-client--area';
const InAreaDetails: any = () => import('@innorium/cn-client--area').then((module) => { return module.InAreaDetails; });
const InAreas: any = () => import('@innorium/cn-client--area').then((module) => { return module.InAreas; });

import { cableJunctionsRoute, cableJunctionDetailsRoute } from '@innorium/cn-client--cable-junction';
const InCableJunctionDetails: any = () => import('@innorium/cn-client--cable-junction').then((module) => { return module.InCableJunctionDetails; });
const InCableJunctions: any = () => import('@innorium/cn-client--cable-junction').then((module) => { return module.InCableJunctions; });

import { branchesRoute, branchDetailsRoute } from '@innorium/cn-client--branch';
const InBranchDetails: any = () => import('@innorium/cn-client--branch').then((module) => { return module.InBranchDetails; });
const InBranches: any = () => import('@innorium/cn-client--branch').then((module) => { return module.InBranches; });

import { wardsRoute, wardDetailsRoute } from '@innorium/cn-client--ward';
const InWardDetails: any = () => import('@innorium/cn-client--ward').then((module) => { return module.InWardDetails; });
const InWards: any = () => import('@innorium/cn-client--ward').then((module) => { return module.InWards; });

import { devicesRoute, deviceDetailsRoute } from '@innorium/cn-client--device';
const InDeviceDetails: any = () => import('@innorium/cn-client--device').then((module) => { return module.InDeviceDetails; });
const InDevices: any = () => import('@innorium/cn-client--device').then((module) => { return module.InDevices; });

import { receiptBooksRoute, receiptBookDetailsRoute } from '@innorium/cn-client--receipt-book';
const InReceiptBookDetails: any = () => import('@innorium/cn-client--receipt-book').then((module) => { return module.InReceiptBookDetails; });
const InReceiptBooks: any = () => import('@innorium/cn-client--receipt-book').then((module) => { return module.InReceiptBooks; });

import { billCollectorsRoute, billCollectorDetailsRoute } from '@innorium/cn-client--bill-collector';
const InBillCollectorDetails: any = () => import('@innorium/cn-client--bill-collector').then((module) => { return module.InBillCollectorDetails; });
const InBillCollectors: any = () => import('@innorium/cn-client--bill-collector').then((module) => { return module.InBillCollectors; });

import { msoRoute, msoMappingsRoute, msoMappingDetailsRoute, msoDetailsRoute, msoFilterRoute, msoFilterDetailsRoute, msoTenantFilterRoute, msoTenantFilterDetailsRoute, msoFilterMappingsRoute } from '@innorium/cn-client--mso';
const InMso: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMso; });
const InMsoMappings: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoMappings; });
const InMsoMappingDetails: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoMappingDetails; });
const InMsoDetails: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoDetails; });
const InMsoFilters: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoFilters; });
const InMsoFilterDetails: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoFilterDetails; });
const InMsoTenantFilters: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoTenantFilters; });
const InMsoTenantFilterDetails: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoTenantFilterDetails; });
const InMsoFilterMappings: any = () => import('@innorium/cn-client--mso').then((module) => { return module.InMsoFilterMappings; });

import { smsTemplateRoute } from '@innorium/cn-client--sms-template';
const InSmsTemplate: any = () => import('@innorium/cn-client--sms-template').then((module) => { return module.InSmsTemplate; });

import { configurationRoute } from '@innorium/cn-client--configuration';
const InConfiguration: any = () => import('@innorium/cn-client--configuration').then((module) => { return module.InConfiguration; });

import { smsConfigurationRoute } from '@innorium/cn-client--sms-configuration';
const InSmsConfiguration: any = () => import('@innorium/cn-client--sms-configuration').then((module) => { return module.InSmsConfiguration; });

import { dashboardRoute } from '@innorium/cn-client--dashboard';
const InDashboard: any = () => import('@innorium/cn-client--dashboard').then((module) => { return module.InDashboard; });

import { sqlReportRoute } from '@innorium/cn-client--sql-reports';
const InSqlReport: any = () => import('@innorium/cn-client--sql-reports').then((module) => { return module.InSqlReport; });

import { v4DigitalLogsRoute } from '@innorium/cn-client--v4-digital-log';
const InV4DigitalLogs: any = () => import('@innorium/cn-client--v4-digital-log').then((module) => { return module.InV4DigitalLogs; });

//import { hathwayDownloadRoute } from '@innorium/cn-client--hathway-bulk';
//const InHathwayDownload: any = () => import('@innorium/cn-client--hathway-bulk').then((module) => { return module.InHathwayDownload; });

import { reportRoute } from '@innorium/cn-client--reports';
const InReports: any = () => import('@innorium/cn-client--reports').then((module) => { return module.InReports; });

import { bulkOperationsRoute } from '@innorium/cn-client--bulk-operations';
const InBulkOperations: any = () => import('@innorium/cn-client--bulk-operations').then((module) => { return module.InBulkOperations; });

import { billSummaryRoute } from '@innorium/cn-client--bill-summary';
const InBillSummary: any = () => import('@innorium/cn-client--bill-summary').then((module) => { return module.InBillSummary; });


Vue.use(Router);

console.log('CN-VERSION: ' + process.env.version);
export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    loginRoute(Constants.baseUrl, InSignIn),
    channelsRoute(Constants.baseUrl, InChannels),
    channelDetailsRoute(Constants.baseUrl, InChannelDetails),
    bouquetsRoute(Constants.baseUrl, InBouquets),
    bouquetDetailsRoute(Constants.baseUrl, InBouquetDetails),
    customerStbsRoute(Constants.baseUrl, InCustomerStbs, false, false),
    customerStbDetailsRoute(Constants.baseUrl, InCustomerStbDetails, false, false),
    customersRoute(Constants.baseUrl, InCustomers, false),
    customerDetailsRoute(Constants.baseUrl, InCustomerDetails),
    billsRoute(Constants.baseUrl, InBills),
    billPreferencesRoute(Constants.baseUrl, InBillPreferences),
    settingsRoute(Constants.baseUrl, InSettings),
    preferenceDetailsRoute(Constants.baseUrl, InPreferenceDetails, 'preferences', false, false),
    countriesRoute(Constants.baseUrl, InCountries),
    countryDetailsRoute(Constants.baseUrl, InCountryDetails),
    statesRoute(Constants.baseUrl, InStates),
    stateDetailsRoute(Constants.baseUrl, InStateDetails),
    citiesRoute(Constants.baseUrl, InCities),
    cityDetailsRoute(Constants.baseUrl, InCityDetails),
    areasRoute(Constants.baseUrl, InAreas),
    areaDetailsRoute(Constants.baseUrl, InAreaDetails),
    cableJunctionsRoute(Constants.baseUrl, InCableJunctions),
    cableJunctionDetailsRoute(Constants.baseUrl, InCableJunctionDetails),
    branchesRoute(Constants.baseUrl, InBranches),
    branchDetailsRoute(Constants.baseUrl, InBranchDetails),
    wardsRoute(Constants.baseUrl, InWards),
    wardDetailsRoute(Constants.baseUrl, InWardDetails),
    devicesRoute(Constants.baseUrl, InDevices),
    deviceDetailsRoute(Constants.baseUrl, InDeviceDetails),
    receiptBooksRoute(Constants.baseUrl, InReceiptBooks),
    receiptBookDetailsRoute(Constants.baseUrl, InReceiptBookDetails),
    billCollectorsRoute(Constants.baseUrl, InBillCollectors),
    billCollectorDetailsRoute(Constants.baseUrl, InBillCollectorDetails),
    smsTemplateRoute(Constants.baseUrl, InSmsTemplate),
    configurationRoute(Constants.baseUrl, InConfiguration),
    smsConfigurationRoute(Constants.baseUrl, InSmsConfiguration),
    dashboardRoute(Constants.baseUrl, InDashboard),
    sqlReportRoute(Constants.baseUrl, InSqlReport),
    msoRoute(Constants.baseUrl, InMso),
    msoMappingsRoute(Constants.baseUrl, InMsoMappings),
    msoMappingDetailsRoute(Constants.baseUrl, InMsoMappingDetails),
    msoDetailsRoute(Constants.baseUrl, InMsoDetails),
    msoFilterRoute(Constants.baseUrl, InMsoFilters),
    msoFilterDetailsRoute(Constants.baseUrl, InMsoFilterDetails),
    msoTenantFilterRoute(Constants.baseUrl, InMsoTenantFilters),
    msoTenantFilterDetailsRoute(Constants.baseUrl, InMsoTenantFilterDetails),
    msoFilterMappingsRoute(Constants.baseUrl, InMsoFilterMappings),
    v4DigitalLogsRoute(Constants.baseUrl, InV4DigitalLogs),
    //hathwayDownloadRoute(Constants.baseUrl, InHathwayDownload),
    bulkOperationsRoute(Constants.baseUrl, InBulkOperations),
    reportRoute(Constants.baseUrl, InReports),
    billSummaryRoute(Constants.baseUrl, InBillSummary)
  ]
})
